"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var constants_1 = require("../constants");
var helpers_1 = require("../helpers");
var SearchBarContext_1 = require("../SearchBarContext");
var suggestions_1 = require("../suggestions");
var SuggestionsContext_1 = require("../SuggestionsContext");
var utils_1 = require("../utils");
var defaultSavedSearches = [];
function useSuggestions() {
    var _a = (0, SearchBarContext_1.useSearchBarContext)(), inputValue = _a.suggestionQuery, _b = _a.savedSearches, savedSearchesFromProps = _b === void 0 ? defaultSavedSearches : _b;
    var suggestedSearches = (0, SuggestionsContext_1.useSuggestionsContext)().suggestions.data;
    var _c = (0, react_1.useState)([]), savedSearches = _c[0], setSavedSearches = _c[1];
    var _d = (0, react_1.useState)([]), recentSearches = _d[0], setRecentSearches = _d[1];
    var _e = (0, react_1.useState)(''), keyPressed = _e[0], setKeyPressed = _e[1];
    var usedArrowKeys = ['ArrowUp', 'ArrowDown'].includes(keyPressed);
    var _f = (0, react_1.useState)([]), filteredSavedSearches = _f[0], setFilteredSavedSearches = _f[1];
    var _g = (0, react_1.useState)([]), filteredRecentSearches = _g[0], setFilteredRecentSearches = _g[1];
    (0, react_1.useEffect)(function () {
        setSavedSearches((0, helpers_1.normalizeSavedSearches)({
            data: savedSearchesFromProps.sort(function (a, b) { return b.savedSearchId - a.savedSearchId; }),
            searchType: constants_1.SearchType.SavedSearch
        }));
    }, [savedSearchesFromProps]);
    (0, react_1.useEffect)(function () {
        setRecentSearches((0, suggestions_1.getInitialRecentSearches)());
    }, []);
    (0, react_1.useEffect)(function () {
        if (usedArrowKeys)
            return;
        setFilteredSavedSearches(function (prevSavedSearches) {
            // Only filter if saved searches are empty or the last item has been removed
            return savedSearches.length || prevSavedSearches.length
                ? savedSearches
                    .filter(function (s) {
                    return s.text.toLowerCase().includes(inputValue.toLowerCase());
                })
                    .map(function (s) { return (__assign(__assign({}, s), { highlightedText: (0, utils_1.highlightText)(s.text, inputValue) })); })
                : prevSavedSearches;
        });
    }, [savedSearches, inputValue, usedArrowKeys]);
    (0, react_1.useEffect)(function () {
        if (usedArrowKeys)
            return;
        setFilteredRecentSearches(function (prevRecentSearches) {
            // Only filter if recent searches are empty or the last item has been removed
            return recentSearches.length || prevRecentSearches.length
                ? recentSearches
                    .filter(function (s) {
                    return s.text.toLowerCase().includes(inputValue.toLowerCase());
                })
                    .map(function (s) { return (__assign(__assign({}, s), { highlightedText: (0, utils_1.highlightText)(s.text, inputValue) })); })
                : prevRecentSearches;
        });
    }, [recentSearches, inputValue, usedArrowKeys]);
    var searches = (0, react_1.useMemo)(function () {
        return (0, helpers_1.combineSearches)({
            recentSearches: filteredRecentSearches,
            savedSearches: filteredSavedSearches
        });
    }, [filteredRecentSearches, filteredSavedSearches]);
    var suggestionResults = (0, react_1.useMemo)(function () {
        return __spreadArray(__spreadArray([], searches, true), suggestedSearches, true);
    }, [searches, suggestedSearches]);
    return (0, react_1.useMemo)(function () { return ({
        setKeyPressed: setKeyPressed,
        setRecentSearches: setRecentSearches,
        suggestionResults: suggestionResults
    }); }, [suggestionResults]);
}
exports.default = useSuggestions;
//# sourceMappingURL=useSuggestions.js.map